import { useMemo } from 'react';
import { useAppContext } from '../../../../../Services/AppContext';
import { createWorkplaceMeta } from '../../../../Meta/Services/meta.service';
import { MetaKey } from '../../../../Meta/Enums/MetaKey.enum';
import useWorkplaceMeta from '../../../../Workplace/Hooks/useWorkplaceMeta';

export default function useIdentificationCode() {
	const { workplaceId } = useAppContext();
	const { workplaceMeta, reFetchWorkplaceMeta } = useWorkplaceMeta(workplaceId);

	const lastIdentificationCode: number = useMemo(() => {
		const meta = workplaceMeta?.find(
			item => item?.key === MetaKey.LAST_IDENTIFICATION_CODE,
		);
		if (meta) {
			return meta.value;
		}
		return 0;
	}, [workplaceMeta]);

	const getNextIdentificationCode = (): string => {
		const nextCode = lastIdentificationCode + 1;
		const formattedCode = nextCode.toString().padStart(3, '0');
		return `S${formattedCode}`;
	};

	const updateLastIdentificationCode = async () => {
		const result = await createWorkplaceMeta({
			workplaceId,
			meta: {
				key: MetaKey.LAST_IDENTIFICATION_CODE,
				value: lastIdentificationCode + 1,
			},
		});
		if (result.status === 200) {
			reFetchWorkplaceMeta();
		}
	};

	return {
		getNextIdentificationCode,
		updateLastIdentificationCode,
	};
}
